// Los íconos que usa el paquete, dibujados en línea. Son pocos y no justifican
// una librería: cada uno es un trazo que hereda el color del texto.
//
// Todos llevan `aria-hidden`: acompañan a un texto o a un `aria-label`, nunca
// son la única pista de qué hace un botón.

export function IconoBuscar() {
  return (
    <svg width="16" height="16" viewBox="0 0 16 16" fill="none" aria-hidden="true">
      <circle cx="7" cy="7" r="5.5" stroke="currentColor" strokeWidth="2" />
      <path d="m11 11 3.5 3.5" stroke="currentColor" strokeWidth="2" strokeLinecap="round" />
    </svg>
  );
}

export function IconoChevronAbajo() {
  return (
    <svg width="16" height="16" viewBox="0 0 16 16" fill="none" aria-hidden="true">
      <path
        d="m4 6 4 4 4-4"
        stroke="currentColor"
        strokeWidth="1.33"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}

export function IconoMas() {
  return (
    <svg width="16" height="16" viewBox="0 0 16 16" fill="none" aria-hidden="true">
      <path d="M8 2v12M2 8h12" stroke="currentColor" strokeWidth="2" strokeLinecap="round" />
    </svg>
  );
}

export function IconoCheck() {
  return (
    <svg width="16" height="16" viewBox="0 0 16 16" fill="none" aria-hidden="true">
      <path
        d="m2.67 8.33 3.33 3.34 7.33-7.34"
        stroke="currentColor"
        strokeWidth="1.67"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}

/** Las tres rayas: abre o pliega el menú lateral. */
export function IconoMenu() {
  return (
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" aria-hidden="true">
      <path d="M4 6h16M4 12h16M4 18h16" stroke="currentColor" strokeWidth="2" strokeLinecap="round" />
    </svg>
  );
}

/** Un marco con la franja derecha marcada: abre o cierra el panel lateral derecho. */
export function IconoPanelDerecho() {
  return (
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" aria-hidden="true">
      <rect x="3" y="4" width="18" height="16" rx="2" stroke="currentColor" strokeWidth="2" />
      <path d="M15 4v16" stroke="currentColor" strokeWidth="2" />
    </svg>
  );
}

/** La «i» en un círculo: el botón que abre el globo de `Ayuda` (#120). */
/**
 * El ⓘ. `relleno` es el de un título, como en el Figma: el círculo lleno del color
 * del texto y la «i» en blanco —el color del fondo, que la recorta—. Sin
 * `relleno`, el de una etiqueta: solo el contorno.
 */
export function IconoInfo({ relleno = false }: { relleno?: boolean }) {
  return (
    <svg width="16" height="16" viewBox="0 0 16 16" fill="none" aria-hidden="true">
      <circle
        cx="8"
        cy="8"
        r={relleno ? 6.67 : 6}
        fill={relleno ? 'currentColor' : 'none'}
        stroke={relleno ? 'none' : 'currentColor'}
        strokeWidth="1.33"
      />
      <path
        d="M8 7.33v3.34M8 5.33h.01"
        stroke={relleno ? 'var(--color-bg-surface)' : 'currentColor'}
        strokeWidth={relleno ? 1.5 : 1.33}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}

/** El ícono del aviso de error del Figma («Ícono/Alerta»). */
export function IconoAlerta() {
  return (
    <svg width="16" height="16" viewBox="0 0 16 16" fill="none" aria-hidden="true">
      <circle cx="8" cy="8" r="6" stroke="currentColor" strokeWidth="1.33" />
      <path
        d="M8 5.33v3.34M8 10.67h.01"
        stroke="currentColor"
        strokeWidth="1.33"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}
